import getSkypeOptions from '../data/store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { select } from 'satcheljs/lib/legacy';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
export default select({
    optionState: function () { return getSkypeOptions(); },
    userOptions: function () {
        return getOptionsForFeature(OwsOptionsFeatureType.SkypeNotifications);
    },
})(function isSkypeOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (isOptionDirty(optionState.imNotification, userOptions.skypeMessageNotification) ||
        isOptionDirty(optionState.callNotification, userOptions.skypeCallingNotification));
});
function isOptionDirty(optionState, userOption) {
    return getFallbackValueIfNull(optionState, userOption) !== userOption;
}
//# sourceMappingURL=isSkypeOptionDirty.js.map